// src/components/ScrollToTop.jsx
// v1 — NEW — forces scroll to top on every route change. React Router does
// not do this automatically; without it, a new page inherits whatever scroll
// position the previous page was at (this is why Order Success appeared to
// "load at the bottom" — Checkout was scrolled down when the user paid).
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}